// ── Scoring logic ──

import type { LacunaRegion, PlayerColor } from './state';

/** Compute total scores from all sealed lacunae */
export function computeScores(
  lacunae: Record<string, LacunaRegion>,
): Record<PlayerColor, number> {
  const scores: Record<PlayerColor, number> = { black: 0, red: 0 };
  for (const lac of Object.values(lacunae ?? {})) {
    scores[lac.color] += lac.boundaryLength;
  }
  return scores;
}

/** Determine the winner, or null for a draw */
export function determineWinner(
  scores: Record<PlayerColor, number>,
): PlayerColor | null {
  if (scores.black > scores.red) return 'black';
  if (scores.red > scores.black) return 'red';
  return null;
}
